export default "__VITE_ASSET__B_u45Alh__"